// src/security/perfisPlano.js

/**
 * Perfil de apresentação de cada plano — COMO a tela se comporta, não o que o
 * usuário pode fazer (isso é capacidades.js).
 *
 * Plano sem entrada aqui usa o padrão: nenhum traço ligado. Diferente das
 * capacidades, o MASTER não herda traços — cada traço muda a tela, e somá-los
 * todos num plano produziria uma tela que nenhum cliente vê.
 */

const PADRAO = Object.freeze({
    /** Resultado apresentado como presença/ausência, não como contagem. */
    resultadoQualitativo: false,
    /** Status geral (conforme/não conforme) no diálogo de processamento. */
    statusGeral: false,
    /**
     * Home no modo estação de tratamento: painel de eficiência com limite
     * regulatório e contagens por análise (não por amostra).
     */
    painelEstacao: false,
    /**
     * Barra lateral clara: cabeçalho branco com a logo do cliente maior, sem o rótulo
     * "Navegação", e o item selecionado em azul claro (layout do produto LEITE).
     */
    menuClaro: false,
    /**
     * Nome do plano para o cliente (ex.: chip "Plano Laticínio" na barra). O código
     * (LEITE) é permanente — está nos enums do crm-back e do hub e nos dados das contas;
     * o nome pode mudar à vontade. null = mostra o código.
     */
    nome: null,
    /** Linha sob a logo na barra lateral, em maiúsculas (ex.: "Microbiologia do leite"). */
    assinatura: null,
    /**
     * Texto ~12% menor em notebook (900–1535 px úteis, com mouse/touchpad): um 14" com
     * escala de 150% vira ~1280 px e o tipo de desktop fica gigante. Tablet (toque) não
     * muda. Ver `html.densidade-notebook` em index.css.
     */
    densidadeNotebook: false,
    /**
     * Gráficos do experimento: a aba Frequências vem primeiro (e é a aberta) — a
     * frequência ressonante é o sinal que o modelo de CBT do leite lê.
     */
    frequenciaPrimeiro: false,
});

const PERFIS = Object.freeze({
    ETA: { resultadoQualitativo: true, statusGeral: true },
    ETE: { statusGeral: true },
    SANEAMENTO: { painelEstacao: true },
    LEITE: {
        menuClaro: true,
        nome: 'Laticínio',
        assinatura: 'Microbiologia do leite',
        densidadeNotebook: true,
        frequenciaPrimeiro: true,
    },
});

export const perfilDoPlano = (plano) => ({ ...PADRAO, ...PERFIS[plano] });

/** Nome do plano para exibir; sem nome definido, o próprio código. */
export const nomeDoPlano = (plano) => perfilDoPlano(plano).nome || plano;
